import * as Sentry from '@sentry/browser';
import { getElementConstantHeight } from '@utils/elements';
import { isPayingUser } from '@utils/user';
import { halfPageManagerPrepareRepeaters as prepareRepeaters } from './halfPageManagerPrepareRepeaters';
import { halfPageManagerInsertRepeaters as insertRepeaters } from './halfPageManagerInsertRepeaters';
import { halfPageManagerUpdateRepeaterHeights as updateRepeaterHeights } from './halfPageManagerUpdateRepeaterHeights';
import { halfPageManagerState as state } from './halfPageManagerState';
import * as els from './halfPageManagerElements';
import { isArticleDetailPage } from './halfPageManagerUtils';

export const halfPageManagerRecalculate = () => {
  // Pokud je platící uživatel, nevykonávat
  if (isPayingUser()) return;

  const oldContent: HTMLElement | undefined = state.getContentElement();
  if (!oldContent) throw new Error('Old content element not found');

  // Kontrola, zda jsme na detailu článku pomocí utility funkce
  const isArticleDetail = isArticleDetailPage();

  // Výpočet celkové výšky obsahu
  let oldContentHeight = 0;

  if (isArticleDetail && els.articleMainContent && els.articleSecondaryContent) {
    // Pro detail článku musíme kombinovat výšky obou elementů
    oldContentHeight =
      els.articleMainContent.offsetHeight + els.articleSecondaryContent.offsetHeight;

    // Přepočítat výšku obsahu obou sloupců dohromady
    Promise.all([
      getElementConstantHeight({ el: els.articleMainContent }),
      getElementConstantHeight({ el: els.articleSecondaryContent }),
    ])
      .then(([mainHeight, secondaryHeight]: [number, number]) => {
        const constantHeight = mainHeight + secondaryHeight;
        // Vložit repeatery
        state.setContentHeight(constantHeight);
        prepareRepeaters(oldContentHeight);
        insertRepeaters();
        updateRepeaterHeights();
      })
      .catch(handleError);
  } else {
    // Standardní výpočet pro ne-článkové stránky
    handleStandardCalculation(oldContent);
  }

  function handleStandardCalculation(contentElement: HTMLElement) {
    const contentHeight = contentElement.offsetHeight;

    getElementConstantHeight({
      el: contentElement,
    })
      .then((constantHeight: number) => {
        // Vložit repeatery
        state.setContentHeight(constantHeight);
        prepareRepeaters(contentHeight);
        insertRepeaters();
        updateRepeaterHeights();
      })
      .catch(handleError);
  }

  function handleError(err: unknown) {
    Sentry.captureException(err);
    if (err instanceof Error) {
      throw new Error(err.message);
    } else {
      throw new Error('Unexpected error in recalculating halfpage adverts.');
    }
  }
};
